document.addEventListener('DOMContentLoaded', () => {
	const headerFixed = document.querySelector('.header-fixed');
	let viewportHeight = window.innerHeight;

	// Met à jour la hauteur du viewport quand on redimensionne
	window.addEventListener('resize', () => {
		viewportHeight = window.innerHeight;
	});

	// Vérifie la position à chaque scroll
	window.addEventListener('scroll', () => {
		if (!headerFixed) return; // sécurité

		if (window.scrollY > viewportHeight) {
			headerFixed.classList.add('scrolled');
		} else {
			headerFixed.classList.remove('scrolled');
		}
	});
});
